export default __webpack_public_path__ + "static/2-5bd39d44050fa7501dcf8008c1e35c05.png";